<div class="table-responsive" [class.overflow-hidden]="settingsAmenitiesService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': settingsAmenitiesService.data.allSettingsAmenities.data.length < 2}">
                <th></th>
                <th (click)="orderBy('internalId', $event)">ID<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('name', $event)">Amenity Name<span class="footable-sort-indicator"></span></th>
                <th *ngIf="settingsAmenitiesService.buildings.length > 1">Building</th>
                <th (click)="orderBy('enableStatus', $event)">Status<span class="footable-sort-indicator"></span></th>
                <th (click)="orderBy('createdAt', $event)" class="footable-sorted-desc">
                    Created On <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="orderBy('createdBy.fullName', $event)">
                    Created By <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="settingsAmenitiesService.canDelete()">Actions</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="settingsAmenitiesService.data.allSettingsAmenities.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>{{item.internalId}}</td>
                    <td>{{item.name}}</td>
                    <td *ngIf="settingsAmenitiesService.buildings.length > 1">
                        <span *ngFor="let building of item.buildingAmenity; let last = last;">
                            {{building.buildingName}}
                            <span *ngIf="building.buildingName && !last">,</span>
                        </span>
                    </td>
                    <td>
                        <span *ngIf="item.enableStatus" class="text-uppercase label label-active">Active</span>
                        <span *ngIf="!item.enableStatus"  class="text-uppercase label label-inactive">Inactive</span>
                    </td>
                    <td>{{item.createdAt | mccDate:true:true}}</td>
                    <td>{{item.createdBy}}</td>
                    <td *ngIf="settingsAmenitiesService.canDelete()" class="td-action-btn">
                        <div class="input-group-btn btn-in-table input-group">
                            <button (click)="deleteAmenity(item, $event)" class="btn btn-white btn-xs delete-button">
                                Delete
                            </button>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of settingsAmenitiesService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td><td>&nbsp;</td><td *ngIf="settingsAmenitiesService.buildings.length > 1"></td><td></td><td></td>
                <td *ngIf="settingsAmenitiesService.canDelete()"></td><td></td><td></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="settingsAmenitiesService.data.allSettingsAmenities.total == 0 && !settingsAmenitiesService.showServiceUnavailable"
        class="text-center">
        <h2>Result Not Found</h2>
        <a class="text-center">
            <broad-match-toggle></broad-match-toggle>
        </a>
    </div>
    <h2 *ngIf="settingsAmenitiesService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-amenities/settings-amenities-list/settings-amenities-list.component.html